import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=180310cc&scoped=true&"
import script from "./Withdrawal.vue?vue&type=script&lang=js&"
export * from "./Withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./Withdrawal.vue?vue&type=style&index=0&id=180310cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180310cc",
  null
  
)

export default component.exports